module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDcgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDAuNzI0NjA5TDEuNSA1LjIyNDYxTDYgOS43MjQ2MSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfMjc1XzMwMSkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yNzVfMzAxIiB4MT0iMy43NSIgeTE9IjAuNzI0NjA5IiB4Mj0iMy43NSIgeTI9IjkuNzI0NjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzkyOTI5MiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM4OTg5ODkiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/goPrev.svg
// module id = BvTg
// module chunks = 0